import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function AlloVersionBanner(_ref) {
  let {
    roundId
  } = _ref;
  const isAlloV1 = roundId.startsWith("0x");
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "fixed z-20 left-0 top-[64px] w-full bg-[#FFEFBE] p-4 text-center font-medium flex items-center justify-center",
      children: [/*#__PURE__*/_jsx(ExclamationCircleIcon, {
        className: "h-5 w-5 mr-2"
      }), /*#__PURE__*/_jsxs("span", {
        children: ["This round has been deployed on Allo ", isAlloV1 ? "v1" : "v2", ". Any projects that you add to your cart will have to be donated to separately from projects on rounds deployed on Allo", " ", isAlloV1 ? "v2" : "v1", ". Learn more", " ", /*#__PURE__*/_jsx("a", {
          href: "#",
          target: "_blank",
          rel: "noreferrer",
          className: "underline",
          children: "here"
        }), "."]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "h-[64px] w-full"
    })]
  });
}